import { IResource } from '../types/resource';

export const resourcesToLoad: IResource[] = [
  { file: '/icon/company logo location.png', name: 'location' },
  { file: '/icon/logo-location.png', name: 'logo-location' },
];
